import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNotMidnight',
  standalone: true
})
export class IsNotMidnightPipe implements PipeTransform {
  transform(dateTime: string | null): boolean {
    return !dateTime ? false : !dateTime.includes('T00:00');
  }
}
